'use client';

import { useState } from 'react';

import { GraphQLResponse, useGraphQLDebug } from '@/fo/api/magento';
import {
  SubscriptionFormStatus,
  UiSubscriptionSectionBase
} from '@/fo/ui/subscription/section/base';

import {
  onSubscribeEmailToNewsletter,
  OnSubscribeEmailToNewsletterResponse
} from '../api/onSubscribeEmailToNewsletter';

export const ClientWrapper = () => {
  const [formStatus, setFormStatus] =
    useState<SubscriptionFormStatus>('default');
  const [errorText, setErrorText] = useState<string>('');
  const [debugResponse, setDebugResponse] = useState<
    GraphQLResponse<OnSubscribeEmailToNewsletterResponse> | undefined
  >();

  useGraphQLDebug(debugResponse, 'subscribeEmailToNewsletter');

  const onSubscribe = async (email: string) => {
    setErrorText((prevValue) => (prevValue ? '' : prevValue));
    const response = await onSubscribeEmailToNewsletter(email);

    if (response.debugInfo) {
      setDebugResponse({
        data: response,
        statusCode: 200,
        debugInfo: response.debugInfo
      });
    }

    if (response.error) {
      setFormStatus('error');
      setErrorText(response.error?.map((error) => error.message).join(' '));
    }
    if (response.data?.status) {
      setFormStatus('success');
    }
  };

  return (
    <UiSubscriptionSectionBase
      onSubscribe={onSubscribe}
      formStatus={formStatus}
      errorText={errorText}
    />
  );
};
